<div *ngIf="!loading">
  <div class="row">
    <div class="col-md-4">
      <label for="companyTp">KYC</label>
      <select class="form-control" [(ngModel)]="selectedCompanyType" (change)="refreshLists()">
        <option *ngFor="let position of companyTypeList" [ngValue]="position.id">
          {{position.text}}
        </option>
      </select>
    </div>
  </div>
  <br />
  <div class="row">
    <div class="col-md-5">
      <div *ngIf="!viewRole">
        <i
          class="mdi md-16 mdi-checkbox-marked"
          *ngIf="selectedRemaingList.length == 0 && getRemaingList.length != 0"
          (click)="selectAllRemaining()"
          >Select All</i
        >
        <i
          class="mdi md-16 mdi-close text-danger"
          *ngIf="selectedRemaingList.length > 0"
          (click)="selectAllRemaining()"
          >Deselect</i
        >
      </div>
      <div class="list-group">
        <div
          *ngFor="let pk of getRemaingList;"
          [ngClass]="{'selectedItem-onBoard-Docs': selectedRemaingList.includes(pk.id)}"
          (click)="viewRole ? return : assign(pk.id)"
          style="margin-bottom: 5px;cursor:pointer;"
          class="first list-group-item"
        >
          <i
            class="mdi md-16 mdi-checkbox-marked"
            style="position: absolute;right:4px;"
            [ngClass]="{'text-success':selectedRemaingList.includes(pk.id)}"
          ></i>
          {{ pk.id | filterList:docList }}
        </div>
      </div>
    </div>
    <div class="col-md-2">
      <div *ngIf="!viewRole">
        <div class="text-center" (click)="assignRequest()">
          <i class="mdi md-xxl mdi-chevron-right"></i>
        </div>
        <div class="text-center" (click)="unAssignRequest()">
          <i class="mdi md-xxl mdi-chevron-left"></i>
        </div>
      </div>
    </div>
    <div class="col-md-5">
      <div *ngIf="!viewRole">
        <i
          class="mdi md-16 mdi-checkbox-marked"
          *ngIf="selectedAssignedList.length == 0 && getAssignedList.length != 0"
          (click)="selectAllAssigned()"
          >Select All</i
        >
        <i
          class="mdi md-16 mdi-close text-danger"
          *ngIf="selectedAssignedList.length > 0"
          (click)="selectAllAssigned()"
          >Deselect</i
        >
      </div>
      <div class="list-group">
        <div
          *ngFor="let pk of getAssignedList;"
          [ngClass]="{'selectedItem-onBoard-Docs': selectedAssignedList.includes(pk.id)}"
          (click)="viewRole ? return : unAssign(pk.id)"
          style="margin-bottom: 5px;cursor:pointer;"
          class="second list-group-item"
        >
          <i
            class="mdi md-16 mdi-checkbox-marked"
            style="position: absolute;right:4px;"
            [ngClass]="{'text-success':selectedAssignedList.includes(pk.id)}"
          ></i>
          {{ pk.id | filterList:docList }}
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="loading" class="dataLoader"></div>
